import { IEmptyObject } from "@Components/shared/types";
import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import { IAddressDetails } from "@Models/IAddressDetails";
import { IEntity } from "@Models/IEntity";

export default class AddressService extends ServiceBase {
    /*
     * Create group address record, setting the owner id
     */
    public async createGroup(ownerId: string, model: IAddressDetails, groupId?: string): Promise<Result<IEntity>> {
        return await this.requestJson<IEntity>({
            url: `/api/Address/CreateGroup/${groupId}/${ownerId}`,
            method: "POST",
            data: model,
        });
    }

    /*
     * Create user address record
     */
    public async createUser(model: IAddressDetails, userId?: string): Promise<Result<IEntity>> {
        return await this.requestJson<IEntity>({
            url: `/api/Address/CreateUser/${userId}`,
            method: "POST",
            data: model,
        });
    }

    /*
     * Fetch address records assigned to the group ids provided.
     */
    public async getGroup(groupIds: string[]): Promise<Result<IAddressDetails[]>> {
        return await this.requestJson<IAddressDetails[]>({
            url: `/api/Address/GetGroup/${groupIds.join(",")}`,
            method: "GET",
        });
    }

    /*
     * Fetch address records assigned to the user ids provided.
     */
    public async getUser(userIds: string[]): Promise<Result<IAddressDetails[]>> {
        return await this.requestJson<IAddressDetails[]>({
            url: `/api/Address/GetUser/${userIds.join(",")}`,
            method: "GET",
        });
    }

    /*
     * Fetch address records assigned to the users within the group id provided.
     */
    public async getGroupUser(groupId: string): Promise<Result<IAddressDetails[]>> {
        return await this.requestJson<IAddressDetails[]>({
            url: `/api/Address/GetGroupUser/${groupId}`,
            method: "GET",
        });
    }

    /*
     * Update address record
     */
    public async update(model: IAddressDetails): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Address/Update/${model.addressId}`,
            method: "PATCH",
            data: model,
        });
    }

    /*
     * Delete address records.
     */
    public async delete(addressId: string): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Address/Delete/${addressId}`,
            method: "DELETE",
        });
    }
}
